import { Rectangle, PolyLine, Circle, Line, PolarLine, Arc, Hatch, Text } from "./utils";
import { dondur, rotatePoint, generateTimestampedId } from './_shared';

 
export function sayacTekFaz(X, Y, Scl, rotation, options) {
  let result = []
  X-=7.5*Scl
  // Ana sayaç kutusu (daha büyük)
  result.push(Rectangle(X - Scl * 45, Y + Scl * 80, 105 * Scl, 140 * Scl, options))
  // Üst büyük daire (ana gösterge)
  result.push(Circle(X + Scl * 10, Y + Scl * 205 , 10 * Scl, options))
  result.push(PolarLine(X - Scl ,Y + Scl * 195, 45 ,30 * Scl,  options))
  result.push(PolarLine(X - Scl * 45 ,Y + Scl * 190, 0 ,105 * Scl,  options))
  
  // Ekran/display alanı
  result.push(Rectangle(X - Scl * 40, Y + Scl * 115, 95 * Scl, 70 * Scl, options))
  
  // İç çerçeve
  result.push(Rectangle(X - Scl * 30, Y + Scl * 160, 75 * Scl, 11 * Scl, options))

  result.push(Circle(X - 28 * Scl, Y + 130 * Scl, 1.5 * Scl, options))
  result.push(Circle(X - 18 * Scl, Y + 130 * Scl, 1.5 * Scl, options))
  
  // Terminal blokları (alt kısım)
  result.push(Rectangle(X - Scl * 35, Y + Scl * 85, 10 * Scl, 25 * Scl, options))
  result.push(Circle(X - 30 * Scl, Y + 105 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X - Scl * 32 ,Y + Scl * 105, 0 ,4 * Scl,  options))
  result.push(Circle(X - 30 * Scl, Y + 90 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X - Scl * 32 ,Y + Scl * 90, 0 ,4 * Scl,  options))

  result.push(Rectangle(X - Scl * 15, Y + Scl * 85, 10 * Scl, 25 * Scl, options))
  result.push(Circle(X - 10 * Scl, Y + 105 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X - Scl * 12 ,Y + Scl * 105, 0 ,4 * Scl,  options))
  result.push(Circle(X - 10 * Scl, Y + 90 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X - Scl * 12 ,Y + Scl * 90, 0 ,4 * Scl,  options))

  result.push(Rectangle(X + Scl * 5, Y + Scl * 85, 10 * Scl, 25 * Scl, options))
  result.push(Circle(X + 10 * Scl, Y + 105 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X + Scl * 8 ,Y + Scl * 105, 0 ,4 * Scl,  options))
  result.push(Circle(X + 10 * Scl, Y + 90 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X + Scl * 8 ,Y + Scl * 90, 0 ,4 * Scl,  options))

  result.push(Rectangle(X + Scl * 25, Y + Scl * 85, 10 * Scl, 25 * Scl, options))
  result.push(Circle(X + 30 * Scl, Y + 105 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X + Scl * 28 ,Y + Scl * 105, 0 ,4 * Scl,  options))
  result.push(Circle(X + 30 * Scl, Y + 90 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X + Scl * 28 ,Y + Scl * 90, 0 ,4 * Scl,  options))


  return dondur(result, rotation, X, Y);
}
export function sayacUcFaz(X,Y,Scl,rotation,options){
let result=[]
X-=7.5*Scl
  result.push(Rectangle(X - Scl * 45, Y + Scl * 80, 105 * Scl, 140 * Scl, options))
  // Üst büyük daire (ana gösterge)
  result.push(Circle(X + Scl * 10, Y + Scl * 205 , 10 * Scl, options))
  result.push(PolarLine(X - Scl ,Y + Scl * 195, 45 ,30 * Scl,  options))
  result.push(PolarLine(X - Scl * 45 ,Y + Scl * 190, 0 ,105 * Scl,  options))
  
  // Ekran/display alanı
  result.push(Rectangle(X - Scl * 40, Y + Scl * 115, 95 * Scl, 70 * Scl, options))
  
  // İç çerçeve
  result.push(Rectangle(X - Scl * 30, Y + Scl * 160, 75 * Scl, 11 * Scl, options))
result.push(Circle(X - 28 * Scl, Y + 130 * Scl, 1.5 * Scl, options))
  result.push(Circle(X - 18 * Scl, Y + 130 * Scl, 1.5 * Scl, options))
  
  // Terminal blokları (alt kısım)
  result.push(Rectangle(X - Scl * 40, Y + Scl * 85, 10 * Scl, 25 * Scl, options))
  result.push(Circle(X - 35 * Scl, Y + 105 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X - Scl * 37 ,Y + Scl * 105, 0 ,4 * Scl,  options))
  result.push(Circle(X - 35 * Scl, Y + 90 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X - Scl * 37 ,Y + Scl * 90, 0 ,4 * Scl,  options))

  result.push(Rectangle(X - Scl * 28, Y + Scl * 85, 10 * Scl, 25 * Scl, options))
  result.push(Circle(X - 23 * Scl, Y + 105 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X - Scl * 25 ,Y + Scl * 105, 0 ,4 * Scl,  options))
  result.push(Circle(X - 23 * Scl, Y + 90 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X - Scl * 25 ,Y + Scl * 90, 0 ,4 * Scl,  options))

  result.push(Rectangle(X - Scl * 16, Y + Scl * 85, 10 * Scl, 25 * Scl, options))
  result.push(Circle(X - 11 * Scl, Y + 105 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X - Scl * 13 ,Y + Scl * 105, 0 ,4 * Scl,  options))
  result.push(Circle(X - 11 * Scl, Y + 90 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X - Scl * 13 ,Y + Scl * 90, 0 ,4 * Scl,  options))

  result.push(Rectangle(X - Scl * 4, Y + Scl * 85, 10 * Scl, 25 * Scl, options))
  result.push(Circle(X + 1 * Scl, Y + 105 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X - Scl * 1 ,Y + Scl * 105, 0 ,4 * Scl,  options))
  result.push(Circle(X + 1 * Scl, Y + 90 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X - Scl * 1 ,Y + Scl * 90, 0 ,4 * Scl,  options))

  result.push(Rectangle(X + Scl * 8, Y + Scl * 85, 10 * Scl, 25 * Scl, options))
  result.push(Circle(X + 13 * Scl, Y + 105 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X + Scl * 11 ,Y + Scl * 105, 0 ,4 * Scl,  options))
  result.push(Circle(X + 13 * Scl, Y + 90 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X + Scl * 11 ,Y + Scl * 90, 0 ,4 * Scl,  options))

  result.push(Rectangle(X + Scl * 20, Y + Scl * 85, 10 * Scl, 25 * Scl, options))
  result.push(Circle(X + 25 * Scl, Y + 105 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X + Scl * 23 ,Y + Scl * 105, 0 ,4 * Scl,  options))
  result.push(Circle(X + 25 * Scl, Y + 90 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X + Scl * 23 ,Y + Scl * 90, 0 ,4 * Scl,  options))

  result.push(Rectangle(X + Scl * 32, Y + Scl * 85, 10 * Scl, 25 * Scl, options))
  result.push(Circle(X + 37 * Scl, Y + 105 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X + Scl * 35 ,Y + Scl * 105, 0 ,4 * Scl,  options))
  result.push(Circle(X + 37 * Scl, Y + 90 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X + Scl * 35 ,Y + Scl * 90, 0 ,4 * Scl,  options))

  result.push(Rectangle(X + Scl * 44, Y + Scl * 85, 10 * Scl, 25 * Scl, options))
  result.push(Circle(X + 49 * Scl, Y + 105 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X + Scl * 47 ,Y + Scl * 105, 0 ,4 * Scl,  options))
  result.push(Circle(X + 49 * Scl, Y + 90 * Scl, 2.5* Scl, options))
  result.push(PolarLine(X + Scl * 47 ,Y + Scl * 90, 0 ,4 * Scl,  options))
return dondur(result,  rotation,X,Y);

}
export function tms(X,Y,Scl,rotation,options){
let result=[]
  result.push(Rectangle(X-Scl*1.5 ,Y-Scl*2.5,3*Scl,5*Scl,options))
  result.push(Rectangle(X-Scl*0.75 ,Y-Scl*1.5,1.5*Scl,3*Scl,options))
 // result.push(PolarLine(X-Scl*0.75 ,Y+Scl*0.8,0,1.5*Scl ,  options))
  result.push(PolarLine(X-Scl*4.75 ,Y+Scl*2.5,0,9.5*Scl ,  options))
  result.push(PolarLine(X-Scl*4.75 ,Y+Scl*5.5,0,9.5*Scl ,  options))
  result.push(PolarLine(X-Scl*4.75 ,Y-Scl*3.5,0,9.5*Scl ,  options))
  result.push(PolarLine(X-Scl*4.75 ,Y-Scl*5.5,0,9.5*Scl ,  options)) 

  let vertices=[
    { x:X-Scl*4.75 ,y:Y-7.5*Scl,z:0 },
    { x:X-Scl*3.75 ,y:Y-7.5*Scl,z:0 },
    { x:X-Scl*3.75 ,y:Y-6*Scl,z:0 },
    { x:X-Scl*2.25 ,y:Y-6*Scl,z:0 },
    { x:X-Scl*2.25 ,y:Y-7.5*Scl,z:0 },
    { x:X-Scl*0.75 ,y:Y-7.5*Scl,z:0 },
    { x:X-Scl*0.75 ,y:Y-6*Scl,z:0 },
    { x:X+Scl*0.75 ,y:Y-6*Scl,z:0 },
    { x:X+Scl*0.75 ,y:Y-7.5*Scl,z:0 },
    { x:X+Scl*2.25 ,y:Y-7.5*Scl,z:0 },
    { x:X+Scl*2.25 ,y:Y-6*Scl,z:0 },
    { x:X+Scl*3.75 ,y:Y-6*Scl,z:0 },
    { x:X+Scl*3.75 ,y:Y-7.5*Scl,z:0 },
    { x:X+Scl*4.75 ,y:Y-7.5*Scl,z:0 },
   // { x:X+Scl*4.75 ,y:Y+7.5*Scl,z:0 },
    { x:X+Scl*4.75 ,y:Y+7.5*Scl,z:0 },
    { x:X+Scl*3.75 ,y:Y+7.5*Scl,z:0 },
    { x:X+Scl*3.75 ,y:Y+6*Scl,z:0 },
    { x:X+Scl*2.25 ,y:Y+6*Scl,z:0 },
    { x:X+Scl*2.25 ,y:Y+7.5*Scl,z:0 },
    { x:X+Scl*0.75 ,y:Y+7.5*Scl,z:0 },
    { x:X+Scl*0.75 ,y:Y+6*Scl,z:0 },
    { x:X-Scl*0.75 ,y:Y+6*Scl,z:0 },
    { x:X-Scl*0.75 ,y:Y+7.5*Scl,z:0 },
    { x:X-Scl*2.25 ,y:Y+7.5*Scl,z:0 },
    { x:X-Scl*2.25 ,y:Y+6*Scl,z:0 },
    { x:X-Scl*3.75 ,y:Y+6*Scl,z:0 },
    { x:X-Scl*3.75 ,y:Y+7.5*Scl,z:0 },
    { x:X-Scl*4.75 ,y:Y+7.5*Scl,z:0 },
     
  ]
  options.shape=true
    result.push(PolyLine(X,Y,vertices,options))
    vertices=[
    { x:X-Scl*0.5 ,y:Y,z:0 },
    { x:X-Scl*0.5 ,y:Y-1.2*Scl,z:0 },
    { x:X-Scl*0.7 ,y:Y-1.2*Scl,z:0 },
    { x:X-Scl*0.7 ,y:Y-1.6*Scl,z:0 },
    { x:X+Scl*0.7 ,y:Y-1.6*Scl,z:0 },
    { x:X+Scl*0.7 ,y:Y-1.2*Scl,z:0 },
    { x:X+Scl*0.5 ,y:Y-1.2*Scl,z:0 },
    { x:X+Scl*0.5 ,y:Y,z:0 },    
  ]
  options.shape=true
   result.push(PolyLine(X,Y,vertices,options))
  
  result.push(...vida(X-Scl*1.5 ,Y-Scl*6.5,Scl ,0.4*Scl, options)) 
  result.push(...vida(X+Scl*1.5 ,Y-Scl*6.5,Scl ,0.4*Scl, options)) 
  result.push(...vida(X-Scl*1.5 ,Y+Scl*6.5,Scl ,0.4*Scl, options)) 
  result.push(...vida(X+Scl*1.5 ,Y+Scl*6.5,Scl ,0.4*Scl, options)) 
  result.push(Circle(X-Scl*2.25 ,Y-Scl*2.5,0.3*Scl, options)) 

 return dondur(result,  rotation,X,Y);

}
export function aos3F(X,Y,Scl,rotation,options){
let result=[]
  result.push(Rectangle(X - Scl ,Y - Scl * 10, 30*Scl,30*Scl,options))
  
  // İç çerçeve
  result.push(Rectangle(X + Scl * 0.1 , Y + Scl * 1, 28 * Scl, 8 * Scl, options))

  result.push(Rectangle(X + Scl * 1 , Y + Scl * 3.5, 26 * Scl, 3 * Scl, options))
  result.push(Rectangle(X + Scl * 11 , Y + Scl * 3.5, 6 * Scl, 3 * Scl, options))

  result.push(...vida(X + Scl * 4,Y + Scl * 14.5, Scl*2 ,10 * Scl, options)) 
  result.push(...vida(X + Scl * 4,Y - Scl * 4.5, Scl*2 ,10 * Scl, options))
  result.push(...vida(X + Scl * 14,Y + Scl * 14.5, Scl*2 ,10 * Scl, options)) 
  result.push(...vida(X + Scl * 14,Y - Scl * 4.5, Scl*2 ,10 * Scl, options)) 
  result.push(...vida(X + Scl * 24,Y + Scl * 14.5, Scl*2 ,10 * Scl, options)) 
  result.push(...vida(X + Scl * 24,Y - Scl * 4.5, Scl*2 ,10 * Scl, options))  


  result.push(Rectangle(X + Scl * 1 , Y + Scl * 20, 6 * Scl, 2 * Scl, options))
  result.push(Rectangle(X + Scl * 1 , Y - Scl * 12, 6 * Scl, 2 * Scl, options))
  result.push(Rectangle(X + Scl * 11 , Y + Scl * 20, 6 * Scl, 2 * Scl, options))
  result.push(Rectangle(X + Scl * 11 , Y - Scl * 12, 6 * Scl, 2 * Scl, options))
  result.push(Rectangle(X + Scl * 21 , Y + Scl * 20, 6 * Scl, 2 * Scl, options))
  result.push(Rectangle(X + Scl * 21 , Y - Scl * 12, 6 * Scl, 2 * Scl, options))


 
 return dondur(result,  rotation,X,Y);

}
export function aos1F(X,Y,Scl,rotation,options){
let result=[]
  result.push(Rectangle(X - Scl * 11 ,Y - Scl * 10, 10*Scl,30*Scl,options))
  result.push(Rectangle(X - Scl * 9 , Y + Scl * 20, 6 * Scl, 2 * Scl, options))
  result.push(Rectangle(X - Scl * 9 , Y - Scl * 12, 6 * Scl, 2 * Scl, options))
  result.push(Rectangle(X - Scl * 10 , Y + Scl * 1, 8 * Scl, 8 * Scl, options))
  result.push(...vida(X - Scl * 6,Y + Scl * 14.5, Scl ,10 * Scl, options)) 
  result.push(...vida(X - Scl * 6,Y - Scl * 4.5, Scl ,10 * Scl, options))

  
 return dondur(result,  rotation,X,Y);

}
export function vida(X,Y,Scl,radius,options){
let result=[]
  result.push(PolarLine(X-Scl*radius*0.4 ,Y,0,radius*0.8*Scl ,  options))
  result.push(PolarLine(X  ,Y-Scl*radius*0.4,90,radius*0.8*Scl ,  options))
  result.push(Circle(X ,Y ,radius/2*Scl, options)) 
return   result  

}     

export function yks1F(X, Y, Scl, rotation, options) {
  let result = []
  
  // Ana kutu
  result.push(Rectangle(X - Scl ,Y - Scl * 10, 10*Scl,30*Scl,options))
  
  // İç çerçeve
  result.push(Rectangle(X + Scl * 0.1 , Y + Scl * 1, 8 * Scl, 8 * Scl, options))

  result.push(Rectangle(X + Scl * 1 , Y + Scl * 3.5, 6 * Scl, 3 * Scl, options))

  result.push(...vida(X + Scl * 4,Y + Scl * 14.5, Scl ,10 * Scl, options)) 
  result.push(...vida(X + Scl * 4,Y - Scl * 4.5, Scl ,10 * Scl, options)) 


  result.push(Rectangle(X + Scl * 1 , Y + Scl * 20, 6 * Scl, 2 * Scl, options))
  result.push(Rectangle(X + Scl * 1 , Y - Scl * 12, 6 * Scl, 2 * Scl, options))

  result.push(Rectangle(X - Scl * 11 ,Y - Scl * 10, 10*Scl,30*Scl,options))
  result.push(Rectangle(X - Scl * 9 , Y + Scl * 20, 6 * Scl, 2 * Scl, options))
  result.push(Rectangle(X - Scl * 9 , Y - Scl * 12, 6 * Scl, 2 * Scl, options))
  result.push(Rectangle(X - Scl * 10 , Y + Scl * 1, 8 * Scl, 8 * Scl, options))
  result.push(...vida(X - Scl * 6,Y + Scl * 14.5, Scl ,10 * Scl, options)) 
  result.push(...vida(X - Scl * 6,Y - Scl * 4.5, Scl ,10 * Scl, options))


  
  // YKŞ yazısı
  let text = { text: "YKŞ", handle: generateTimestampedId(), textHeight: 8 * Scl }
  result.push(Text(X - 3 * Scl, Y + 25 * Scl, text, 0, options))

  return dondur(result, rotation, X, Y);
}

export function yks3F(X, Y, Scl, rotation, options) {
  let result = []
  X++
  // Ana kutu
  result.push(Rectangle(X - Scl ,Y - Scl * 10, 30*Scl,30*Scl,options))
  
  // İç çerçeve
  result.push(Rectangle(X + Scl * 0.1 , Y + Scl * 1, 28 * Scl, 8 * Scl, options))

  result.push(Rectangle(X + Scl * 1 , Y + Scl * 3.5, 26 * Scl, 3 * Scl, options))
  result.push(Rectangle(X + Scl * 11 , Y + Scl * 3.5, 6 * Scl, 3 * Scl, options))

  result.push(...vida(X + Scl * 4,Y + Scl * 14.5, Scl ,10 * Scl, options)) 
  result.push(...vida(X + Scl * 4,Y - Scl * 4.5, Scl ,10 * Scl, options))
  result.push(...vida(X + Scl * 14,Y + Scl * 14.5, Scl ,10 * Scl, options)) 
  result.push(...vida(X + Scl * 14,Y - Scl * 4.5, Scl ,10 * Scl, options)) 
  result.push(...vida(X + Scl * 24,Y + Scl * 14.5, Scl ,10 * Scl, options)) 
  result.push(...vida(X + Scl * 24,Y - Scl * 4.5, Scl ,10 * Scl, options))  


  result.push(Rectangle(X + Scl * 1 , Y + Scl * 20, 6 * Scl, 2 * Scl, options))
  result.push(Rectangle(X + Scl * 1 , Y - Scl * 12, 6 * Scl, 2 * Scl, options))
  result.push(Rectangle(X + Scl * 11 , Y + Scl * 20, 6 * Scl, 2 * Scl, options))
  result.push(Rectangle(X + Scl * 11 , Y - Scl * 12, 6 * Scl, 2 * Scl, options))
  result.push(Rectangle(X + Scl * 21 , Y + Scl * 20, 6 * Scl, 2 * Scl, options))
  result.push(Rectangle(X + Scl * 21 , Y - Scl * 12, 6 * Scl, 2 * Scl, options))

  result.push(Rectangle(X - Scl * 11 ,Y - Scl * 10, 10*Scl,30*Scl,options))
  result.push(Rectangle(X - Scl * 9 , Y + Scl * 20, 6 * Scl, 2 * Scl, options))
  result.push(Rectangle(X - Scl * 9 , Y - Scl * 12, 6 * Scl, 2 * Scl, options))
  result.push(Rectangle(X - Scl * 10 , Y + Scl * 1, 8 * Scl, 8 * Scl, options))
  result.push(...vida(X - Scl * 6,Y + Scl * 14.5, Scl ,10 * Scl, options)) 
  result.push(...vida(X - Scl * 6,Y - Scl * 4.5, Scl ,10 * Scl, options))


  
  // YKŞ yazısı
 // let text = { text: "YKŞ", handle: generateTimestampedId(), textHeight: 8 * Scl }
 // result.push(Text(X - 3 * Scl, Y + 25 * Scl, text, 0, options))

  return dondur(result, rotation, X, Y);
}

export function kakrView(X, Y, Scl, rotation, options) {
  let result = []
  
  // Ana dikdörtgen kutu
  result.push(Rectangle(X - Scl * 10, Y - Scl * 8, 20 * Scl, 16 * Scl, options))
  
  // İç bölmeler
  result.push(Rectangle(X - Scl * 8, Y - Scl * 6, 16 * Scl, 4 * Scl, options))
  result.push(Rectangle(X - Scl * 8, Y, 16 * Scl, 4 * Scl, options))
  
  // Test butonu (küçük daire)
  result.push(Circle(X - 6 * Scl, Y + 2 * Scl, 1.5 * Scl, options))
  
  // LED gösterge (küçük kare)
  result.push(Rectangle(X + 4 * Scl, Y + 1 * Scl, 3 * Scl, 2 * Scl, options))
  
  // Bağlantı terminalleri
  for (let i = 0; i < 4; i++) {
    result.push(Rectangle(X - 7 * Scl + i * 4.5 * Scl, Y - 7 * Scl, 2 * Scl, 1.5 * Scl, options))
    result.push(Rectangle(X - 7 * Scl + i * 4.5 * Scl, Y + 5.5 * Scl, 2 * Scl, 1.5 * Scl, options))
  }
  
  // KAKR yazısı
  let text = { text: "KAKR", handle: generateTimestampedId(), textHeight: 2 * Scl }
  result.push(Text(X - 4 * Scl, Y - 2 * Scl, text, 0, options))

  return dondur(result, rotation, X, Y);
}

export function hatchedCircle(X,Y,R,Scl,options){
  const path=[
    {IsClosedFlag:1,
      edgeType:"Line",
      NumberOfPolylineVertices:2,
      bulge:true,
      points:[
        X-R*Scl, Y,1,
        X+R*Scl, Y,1
      ]
    }
  ]
 return Hatch(X   ,Y  , path, 0, options)
}